import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ProfileRepository from '../../repositories/ProfileRepository';
import ProfileDataRepository from '../../../data/repositories/ProfileDataRepository';

export default function* execute(action: any): any {
  try {
    const { period } = action;
    yield put({ type: Types.GET_PROFILE_TURN_BY_PERIOD_REQUEST });
    const profileRepository: ProfileRepository = new ProfileDataRepository();
    const profileResponse = yield call(
      profileRepository.getProfileTurnByPeriod,
      period
    );

    if (!profileResponse) {
      yield put({
        type: Types.GET_PROFILE_TURN_BY_PERIOD_FAILURE,
        error: 'No se encontró el turno'
      });
      return;
    }
    yield put({
      type: Types.GET_PROFILE_TURN_BY_PERIOD_SUCCESS,
      data: profileResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_PROFILE_TURN_BY_PERIOD_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del turno.'
    });
  }
}
